export interface SpeedDial {
  id: number
  label: string
  number: string
}
export type SpeedDialState = Map<number, SpeedDial>

export interface UserSpeedDialMap {
  [userId: number]: SpeedDialState
}

export enum PhoneStatus {
  INITIAL = 'INITIAL',
  READY = 'READY',
  CALL_CONNECTING = 'CALL_CONNECTING',
  RINGING = 'RINGING',
  CALL_ACTIVE = 'CALL_ACTIVE',
  TRANSPORT_DISCONNECTED = 'TRANSPORT_DISCONNECTED',
  ERROR = 'ERROR',
  MIC_DENIED = 'MIC_DENIED',
}

export enum MicrophonePermissionStatus {
  GRANTED = 'GRANTED',
  DENIED = 'DENIED',
  PROMPT = 'PROMPT',
  UNKNOWN = 'UNKNOWN',
}

export enum TransportConnectionState {
  INITIAL = 'INITIAL',
  CONNECTED = 'CONNECTED',
  DISCONNECTED = 'DISCONNECTED',
}
